export default {
  nav: {
    home: '首页',
    articles: '文章',
    tech: '技术',
    software: '软件',
    tutorial: '教程',
    resource: '资源',
    news: '资讯',
    tools: '工具箱',
    about: '关于',
    sponsor: '会员',
    copyright: '版权声明'
  },
  header: {
    searchPlaceholder: '搜索文章...',
    searchMobilePlaceholder: '搜索文章、工具...',
    search: '搜索',
    navLabel: '导航',
    drawerHint: '滑动浏览 · 点按导航',
    openMenu: '打开菜单',
    closeMenu: '关闭菜单',
    langZh: '中文',
    langEn: 'EN'
  },
  footer: {
    nav: '导航',
    about: '关于',
    copyright: '版权声明',
    feedback: '反馈建议',
    followUs: '关注我们',
    channelsHint: '悬停或点击二维码可放大扫码',
    allRights: '版权所有',
    contactEmail: '联系邮箱',
    qrAlt: '{label}二维码',
    qrEnlarge: '{label}放大二维码',
    close: '关闭',
    wechatScan: '打开微信扫一扫',
    filingHint: '当前域名备案：{label}',
    filingHintEmpty: '当前域名备案'
  },
  home: {
    readMore: '阅读全文',
    noCarousel: '暂无轮播文章',
    noCarouselHint: '在后台文章管理中开启「首页轮播展示」',
    latest: '最新',
    featured: '精华',
    views: '阅读',
    softwareTitle: '软件推荐',
    softwareSubtitle: '精选实用软件，小工具、办公、开发应有尽有',
    tutorialTitle: '教程文章',
    tutorialSubtitle: '从入门到实战，系统化学习路径',
    resourceTitle: '资源分享',
    resourceSubtitle: '学习路线、开源项目、书籍推荐',
    techTitle: '技术文章',
    techSubtitle: '前端开发、工程化与性能优化',
    all: '全部',
    viewMore: '查看更多',
    techCatTitle: '{cat}技术文章',
    emptyCategory: '该分类暂无文章',
    seoIndex: '全站文章索引'
  },
  articles: {
    count: '共 {n} 篇文章',
    searchPrefix: '搜索：{q}',
    all: '全部',
    tech: '技术',
    software: '软件',
    tutorial: '教程',
    resource: '资源',
    news: '资讯',
    titleAll: '全部文章',
    titleTech: '技术文章',
    titleSoftware: '软件推荐',
    titleTutorial: '教程文章',
    titleResource: '资源分享',
    titleNews: '资讯动态',
    subCategory: '子分类',
    softwareCats: '软件分类',
    tutorialCats: '教程分类',
    resourceCats: '资源分类',
    techCats: '技术分类',
    tags: '标签',
    empty: '没有找到相关文章',
    featured: '精华'
  },
  article: {
    home: '首页',
    body: '正文',
    back: '返回',
    repostFrom: '转载自：',
    readMinutes: '约 {n} 分钟',
    readAbout: '读完约',
    views: '阅读',
    copyLink: '复制链接',
    loadingBody: '正在加载正文…',
    thanks: '感谢阅读',
    moreType: '更多{type}',
    related: '相关推荐',
    loading: '正在加载文章…',
    notFound: '文章不存在',
    backToList: '返回文章列表',
    translationFallback: '暂无英文译文，显示中文原文',
    original: '原创',
    repost: '转载',
    publishedAt: '发布于 {date}',
    updatedAt: '更新于 {date}',
    publish: '发布',
    update: '更新',
    copied: '链接已复制',
    copyFailed: '复制失败',
    uncategorized: '未分类',
    authorDefault: '博主',
    recommend: '推荐文章',
    hotTags: '热门标签',
    thisArticle: '本文信息',
    category: '分类',
    authorBio: '专注技术分享与内容创作',
    updatedShort: '更',
    list: '文章列表'
  },
  friendLinks: {
    title: '友情链接',
    subtitle: '与优秀站点互联互通'
  },
  share: {
    label: '分享',
    copyTo: '复制链接分享到{name}',
    preview: '卡片预览',
    collapse: '收起预览',
    copied: '已复制',
    copyLink: '复制链接',
    previewTip: '粘贴到微信、QQ 等平台时将显示以上卡片样式',
    wechat: '微信',
    qq: 'QQ',
    weibo: '微博'
  },
  lock: {
    login: '登录可见',
    member: '会员专享',
    paid: '付费内容',
    public: '公开',
    loginMsg: '登录后即可阅读本节内容',
    memberMsg: '开通会员后可阅读会员专享内容',
    paidMsg: '使用 {n} {name} 解锁本节内容',
    paidMsgPlain: '使用{name}解锁本节内容',
    myPoints: '我的{name}：',
    insufficient: '（不足 {n}）',
    loginRead: '立即登录阅读',
    openMember: '开通赞助会员',
    unlock: '{n} {name} 解锁',
    getPoints: '获取{name}',
    loginFirst: '先登录'
  },
  tools: {
    badge: '在线工具箱',
    heroTitle: '实用工具，即开即用',
    heroDesc: 'PDF、图片、码制、站长、生活、运维与配置转换 — 全部在浏览器本地处理，安全快捷，无需上传服务器。',
    countTools: '款工具',
    countCats: '大分类',
    localPct: '本地处理',
    searchPlaceholder: '搜索工具，如 PDF 合并、二维码…',
    frequent: '常用工具',
    frequentHintLogin: '按你的使用习惯同步到账号，置顶可优先显示',
    frequentHintGuest: '本机记录最近使用；登录后可跨设备同步',
    clear: '清空',
    clearConfirm: '确定清空常用工具记录？',
    cleared: '已清空',
    pin: '置顶',
    unpin: '取消置顶',
    removeFrequent: '从常用移除',
    frequentEmpty: '使用过的工具会出现在这里，点击即可直达',
    all: '全部',
    toolsInCat: '{n} 个工具',
    empty: '没有找到匹配的工具',
    notFound: '工具不存在',
    backHub: '返回工具箱',
    allTools: '全部工具',
    loginRequired: '登录后使用',
    loginTip: '该工具需要登录账号后才能使用，登录后可在浏览器本地安全处理文件。',
    loginNow: '立即登录',
    tip: '提示',
    onlineTool: '在线工具',
    ui: {
      drop: '点击或拖拽文件到此处',
      localHint: '支持本地处理，文件不会上传到服务器',
      localHintMax: '支持本地处理，单张不超过 {n}MB',
      fileTooLarge: '文件不能超过 {n}MB',
      process: '开始处理',
      convert: '转换',
      copy: '复制',
      copied: '已复制',
      copyManual: '请手动选择复制',
      paste: '粘贴',
      pasted: '已粘贴',
      clipboardFail: '无法读取剪贴板',
      copyFail: '复制失败',
      input: '输入',
      output: '输出',
      encode: '编码',
      decode: '解码',
      escape: '转义',
      unescape: '反转义',
      format: '格式化',
      minify: '压缩',
      lookup: '查询',
      yes: '是',
      no: '否',
      swapIo: '上下交换',
      result: '结果…',
      optional: '可选',
      required: '必填',
      done: '处理完成',
      fail: '处理失败',
      generate: '生成',
      genOk: '生成成功',
      genFail: '生成失败',
      recognize: '识别',
      recOk: '识别成功',
      download: '下载',
      downloadImage: '下载图片',
      preview: '预览',
      empty: '留空'
    },
    pdf: {
      config: '处理参数',
      dropPdf: '上传 PDF 文件',
      dropPdfs: '上传多个 PDF 文件',
      dropImages: '上传一张或多张图片',
      dropFirst: '上传第一个 PDF',
      dropSecondAlt: '上传第二个 PDF（交替穿插）',
      dropInsert: '上传要插入的 PDF',
      dropLogo: '上传水印 / Logo 图片',
      dropSign: '上传签名图片（可选）',
      splitRange: '拆分范围（如 1-3;5;8-10）',
      splitPh: '留空表示整本一份',
      deletePages: '删除页码（如 1-3,5,8-10）',
      exportFormat: '导出格式',
      page: '页码',
      signText: '签名文字',
      rotateAll: '整本统一旋转',
      rotateHint: '也可在下方缩略图为单页单独设置',
      pageN: '第 {n} 页',
      angle: '角度',
      reorderHint: '拖拽调整顺序（也可点左右箭头）',
      origPage: '#{i} · 原第 {n} 页',
      insertAfter: '插入位置（第几页之后，0=开头）',
      marginTop: '上边距 (pt)',
      marginBottom: '下边距 (pt)',
      marginLeft: '左边距 (pt)',
      marginRight: '右边距 (pt)',
      headerH: '页眉高度 (pt)',
      footerH: '页脚高度 (pt)',
      paper: '目标纸张',
      nup: '拼版',
      wmText: '水印文字',
      wmPh: '支持多行',
      fontSize: '字号',
      opacity: '透明度',
      rotate: '角度',
      color: '颜色',
      mode: '模式',
      tile: '平铺',
      center: '居中',
      qrContent: '二维码内容',
      qrPh: '链接或文本',
      scale: '缩放',
      position: '位置',
      posCenter: '居中',
      posBR: '右下',
      posTR: '右上',
      posBL: '左下',
      posBC: '底部居中',
      posBR2: '底部靠右',
      posTC: '顶部居中',
      pageStart: '起始页码',
      template: '模板',
      header: '页眉',
      footer: '页脚',
      metaTitle: '标题',
      metaAuthor: '作者',
      metaSubject: '主题',
      metaKeywords: '关键词',
      metaCreator: '创建者',
      metaProducer: '制作程序',
      gray: '灰度',
      bw: '黑白',
      format: '格式',
      extract: '提取结果',
      links: '链接列表（{n}）',
      loadMeta: '读取当前元数据',
      preview40: '仅预览前 40 页（共 {n} 页），处理仍作用于全部页面',
      metaLoaded: '已读取元数据（共 {n} 页）',
      readFail: '读取失败',
      pdfReady: 'PDF 已生成并开始下载',
      mergeOk: '合并完成',
      altMergeOk: '交替合并完成',
      exportedImgs: '已导出 {n} 张图片',
      splitOk: '已拆分为 {n} 个文件',
      compressOk: '压缩完成（浏览器端基础优化）',
      optimizeOk: '优化完成',
      unlockOk: '已尝试移除权限限制并重存',
      deletedPages: '已删除 {n} 页',
      blankOk: '已删除空白页：{pages}',
      rotateOk: '旋转完成',
      reverseOk: '逆序完成',
      reorderOk: '重排完成',
      reorderPartial: '重排完成（前 {n} 页已调整，其余保持原序）',
      waitThumbs: '请等待缩略图生成后再排序',
      needPages: '请指定要删除的页码',
      noImages: '未找到可提取的内嵌图片',
      noLinks: '未找到超链接',
      unknown: '未知工具',
      insertOk: '插入完成',
      cropOk: '裁剪完成',
      hfOk: '已按边距裁切页眉页脚区域',
      sizeOk: '统一尺寸完成',
      nupOk: '拼版完成',
      wmTextOk: '文字水印已添加',
      wmLogoOk: 'LOGO 水印已添加',
      wmQrOk: '二维码水印已添加',
      pageNumOk: '页码已添加',
      hfAddOk: '页眉页脚已添加',
      textOk: '文字已提取并下载',
      extractImgs: '已提取 {n} 张图片',
      extractLinks: '已提取 {n} 个链接',
      metaSaved: '元数据已保存',
      metaCleared: '元数据已清除',
      grayOk: '灰度 / 黑白转换完成',
      longOk: '超长图已导出',
      signOk: '签名 PDF 已导出',
      actions: {
        'pdf-to-images': '导出图片',
        'images-to-pdf': '生成 PDF',
        'pdf-split': '拆分 PDF',
        'pdf-merge': '合并 PDF',
        'pdf-merge-alt': '交替合并',
        'pdf-compress': '压缩 PDF',
        'pdf-optimize': '优化并下载',
        'pdf-delete-pages': '删除并导出',
        'pdf-blank-pages': '删除空白页',
        'pdf-rotate': '旋转并下载',
        'pdf-reverse': '逆序并下载',
        'pdf-reorder': '按新顺序导出',
        'pdf-insert': '插入并下载',
        'pdf-crop': '裁剪并下载',
        'pdf-page-size': '统一尺寸并下载',
        'pdf-nup': '拼版并下载',
        'pdf-watermark': '添加水印',
        'pdf-logo-watermark': '添加 LOGO 水印',
        'pdf-qr-watermark': '添加二维码水印',
        'pdf-page-number': '添加页码',
        'pdf-header-footer': '添加页眉页脚',
        'pdf-remove-hf': '裁切并下载',
        'pdf-extract-text': '提取文字',
        'pdf-extract-images': '提取图片',
        'pdf-extract-links': '提取链接',
        'pdf-metadata': '保存元数据',
        'pdf-clear-metadata': '清除并下载',
        'pdf-grayscale': '转换并下载',
        'pdf-long-image': '导出长图',
        'pdf-unlock': '解锁并下载',
        'pdf-sign': '添加签名并导出'
      }
    },
    image: {
      drop: '上传图片',
      dropStitch: '上传多张图片进行拼接',
      dropResize: '上传要缩小的图片',
      srcSize: '原图尺寸',
      resizeMode: '缩放方式',
      custom: '自定义宽高',
      percent: '按比例',
      maxSide: '限制最长边',
      lockRatio: '锁定比例',
      lockTip: '开启后改宽或高，另一边按原图比例自动计算',
      width: '目标宽度',
      height: '目标高度',
      ratioBase: '以谁为准',
      byWidth: '以宽度为准',
      byHeight: '以高度为准',
      scale: '缩放比例',
      scaleTip: '例如 10% 可将 1024px 缩到约 102px',
      maxW: '最大宽度',
      maxH: '最大高度',
      maxTip: '在框内等比缩小，不会放大超过原图',
      exportFmt: '导出格式',
      keepFmt: '原格式',
      quality: '导出质量',
      preview: '预览结果',
      scaleAbout: '（约 {n}）',
      scaleWH: '宽 {w}% / 高 {h}%',
      stitchH: '横向拼接',
      stitchV: '纵向拼接',
      block: '块大小',
      maxBytes: '最大体积',
      qualityShort: '质量',
      wmPh: '水印文字',
      pos: '位置',
      readFail: '无法读取图片尺寸',
      resized: '已缩小为 {w}×{h}，开始下载',
      gridOk: '九宫格图片已打包下载',
      doneDl: '处理完成，已开始下载'
    },
    code: {
      inputPh: '输入文本或链接',
      copybookPh: '输入汉字，如：青苹果博客',
      logo: '上传 Logo 图片',
      uploadCode: '上传含码图片',
      tabFile: '上传图片',
      tabCam: '摄像头扫码',
      stopScan: '停止扫码',
      startCam: '开启摄像头',
      camDefault: '请允许浏览器使用摄像头权限。',
      hintQr: '将二维码对准取景框…',
      hintBar: '将一维条码对准取景框…',
      hintDm: '将 DataMatrix 码对准取景框…',
      hintHx: '将汉信码对准取景框…',
      tipQr: '建议在光线充足处使用后置摄像头，识别成功后会自动停止。',
      tipBar: '条码请尽量水平对准取景框，保持清晰无反光。',
      tipDm: 'DataMatrix 为正方形点阵码，请完整放入取景框。',
      tipHx: '请将完整汉信码放入取景框，保持清晰无反光；识别成功后会自动停止。',
      hintDefault: '将码对准取景框…',
      camDenied: '无法访问摄像头，请检查浏览器权限或使用 HTTPS',
      scanOk: '扫码成功',
      recFail: '识别失败，请换一张清晰的图片',
      camUnsupported: '当前环境不支持摄像头',
      videoNotReady: '视频组件未就绪'
    },
    convert: {
      tip: '粘贴配置规则，点击转换。复杂规则请人工核对后使用。',
      swap: '交换输入/输出',
      copyOut: '复制结果',
      phApache: '粘贴 Apache .htaccess 规则…',
      phNginx: '粘贴 Nginx rewrite 规则…'
    },
    ts: {
      tip: 'Unix 时间戳与日期时间互转，支持秒 / 毫秒；左侧改时间戳、右侧改日期，即时同步。',
      tsToDate: '时间戳 → 日期',
      dateToTs: '日期 → 时间戳',
      tsPh: '如 1704067200 或 1704067200000',
      nowSec: '当前秒',
      nowMs: '当前毫秒',
      local: '本地时间',
      utc: 'UTC',
      iso: 'ISO',
      weekday: '星期',
      weekdayVal: '周{d}',
      seconds: '秒级',
      millis: '毫秒',
      pickDate: '选择日期时间',
      datePh: '或粘贴：2024-01-01 12:00:00',
      secTs: '秒级时间戳',
      msTs: '毫秒时间戳',
      localShort: '本地',
      parseTs: '无法解析时间戳',
      invalidDate: '日期无效',
      parseDate: '无法解析日期',
      days: {
        日: '日',
        一: '一',
        二: '二',
        三: '三',
        四: '四',
        五: '五',
        六: '六'
      }
    },
    wm: {
      urlMode: '编码模式',
      urlAll: '全编码',
      phText: '输入文本',
      phUrl: '输入 URL 或文本',
      phJson: '粘贴 JSON',
      radix: '进制转换',
      radixFrom: '源进制',
      baseN: '{n} 进制',
      autoBase: '自动识别',
      phRadix: '如 255、0xff、0b1010',
      htmlEsc: 'HTML 转义',
      phHtml: '输入 HTML / 文本',
      uuidTip: '生成 RFC4122 UUID v4（随机）。',
      genUuid: '生成 UUID',
      genUuid5: '生成 5 个',
      phUnicode: '输入文本或 \\uXXXX',
      phHash: '输入要哈希的文本',
      encodeFail: '编码失败',
      decodeFail: '解码失败',
      jsonErr: 'JSON 格式错误: {msg}',
      convertFail: '转换失败',
      dec: '十进制',
      bin: '二进制',
      oct: '八进制',
      hex: '十六进制',
      b32: '32 进制',
      b36: '36 进制',
      metaTitle: '标题',
      metaDesc: '描述',
      metaKw: '关键词',
      metaUrl: '链接',
      metaImg: '图片',
      ogImg: 'OG 图片 URL',
      copyCode: '复制代码',
      allowAll: '允许全部',
      disallow: '禁止路径',
      copyRobots: '复制 robots.txt'
    },
    json: {
      tip: 'JSON 格式化、压缩、校验、键排序与字符串转义；全部在本地浏览器完成。',
      validate: '校验',
      sortKeys: '键排序',
      escapeStr: '转义为字符串',
      unescape: '去转义',
      indentN: '缩进 {n}',
      phIn: '粘贴 JSON…',
      done: '完成',
      fmtOk: '格式化成功',
      minOk: '压缩成功',
      sorted: '键已排序',
      escaped: '已转义为 JSON 字符串',
      escapeFail: '转义失败',
      unescaped: '已去除转义',
      unescapeFail: '去转义失败'
    },
    fmt: {
      tip: 'HTML / JS / CSS / XML / PHP 格式化与压缩；支持 XML↔JSON、PHP 源码混淆加密。本地处理，不上传。',
      xmlJson: 'XML ↔ JSON',
      phpEnc: 'PHP 加密',
      copyOut: '复制结果',
      inputLang: '输入 · {lang}',
      phLang: '粘贴 {lang} 代码…',
      xmlRoot: 'JSON→XML 根节点名',
      inXmlJson: '输入（XML 或 JSON）',
      phXmlJson: '粘贴 XML 或 JSON…',
      swap: '交换',
      encMode: '加密方式',
      encrypt: '加密 / 混淆',
      decrypt: '尝试解密',
      phpWarn: '仅做源码混淆，非强加密；可用于简单防直接阅读，不可替代真正的安全方案。',
      phpSrc: 'PHP 源码',
      phPhp: '粘贴 PHP 源码，例如：echo \'hello\';',
      fmtOk: '格式化成功',
      fmtFail: '格式化失败',
      minOk: '压缩成功',
      minFail: '压缩失败',
      xmlOk: 'XML → JSON 成功',
      jsonOk: 'JSON → XML 成功',
      convertFail: '转换失败',
      mixOk: '混淆完成',
      encFail: '加密失败',
      decOk: '解密完成',
      decFail: '解密失败'
    },
    byte: {
      tip: '输入数值并选择单位，换算为各字节单位。小数点按你输入的为准，不会自动补零。可选 1024（KiB/MiB）或 1000（KB/MB）进制。',
      ph: '输入数值，如 1024 或 1.5',
      base1024: '1024 进制',
      base1000: '1000 进制',
      unit: '单位',
      value: '数值',
      action: '操作',
      invalid: '请输入有效非负数字'
    },
    ascii: {
      tip: '输入英文字母、数字或常见符号，选择字体风格即可生成线条字（ASCII 艺术字）。可用 {nl} 或直接回车换行；中文暂不支持；粘贴到别处时请使用等宽字体。',
      ph: '例如：wyqii cn 或 Hello\\nWorld（\\n 表示换行）',
      font: '字体风格',
      layoutDefault: '默认布局',
      layoutFull: '全宽',
      layoutFitted: '适配',
      layoutSmush: '挤压',
      empty: '在上方输入文字后即可预览线条字',
      genFail: '生成失败，请检查输入或换一种字体',
      gallery: '全部风格预览',
      collapse: '收起',
      use: '使用',
      browse: '浏览全部字体效果',
      switched: '已切换为 {name}',
      qClassic: '经典',
      qStandard: '标准',
      qBig: '大号',
      qSlant: '斜体',
      qBanner: '横幅',
      qBlock: '方块',
      qBubble: '气泡',
      qDigital: '数码',
      qStar: '星战'
    },
    whois: {
      tabWhois: '域名 WHOIS',
      tabUa: 'User-Agent',
      tipWhois: '查询域名注册信息（WHOIS）。结果依赖服务器网络与目标注册局策略，部分域名可能受限。',
      domain: '域名：{d}',
      server: 'WHOIS 服务器：{s}',
      copyOut: '复制结果',
      empty: '未返回 WHOIS 内容',
      fail: 'WHOIS 查询失败',
      tipUa: '解析当前或自定义 User-Agent，并提供常用浏览器 / 小程序 / 爬虫预设一键复制。',
      useLocal: '使用本机 UA',
      phUa: '粘贴 User-Agent',
      parse: '解析',
      copyUa: '复制 UA',
      browser: '浏览器',
      os: '系统',
      device: '设备',
      engine: '引擎',
      mobile: '移动端',
      wechat: '微信',
      bot: '爬虫',
      length: '长度',
      presets: '常用预设',
      use: '使用'
    },
    mac: {
      tip: '根据 MAC / OUI 查询网卡厂商。本地收录约 {n} 条常见厂商，未命中时可尝试在线查询。',
      ph: '例如 AA:BB:CC:DD:EE:FF 或 AABBCC',
      online: '在线补查',
      fail: '查询失败',
      onlineFail: '在线查询失败',
      invalid: '请输入至少 6 位十六进制（OUI）或完整 MAC',
      mac: '规范化 MAC',
      oui: 'OUI',
      vendor: '厂商',
      unknown: '未找到',
      localBit: '本地管理位',
      multicast: '组播',
      source: '来源',
      srcLocal: '本地',
      srcNone: '未命中',
      srcOnline: '在线',
      tipHit: '命中本地常见厂商库',
      tipMiss: '本地库未收录，可尝试服务端在线查询',
      tipOnline: '在线查询命中',
      tipOnlineMiss: '在线亦未找到'
    },
    regex: {
      tip: '编写 / 测试正则，支持常用预设与元字符速查；可在线匹配高亮与替换。',
      presets: '常用预设',
      phPattern: '正则表达式',
      insert: '插入：',
      sample: '测试文本',
      phSample: '在此粘贴要匹配的文本',
      replace: '替换为（可选，$1 引用分组）',
      phReplace: '替换内容',
      test: '测试',
      copyRe: '复制正则',
      copyRepl: '复制替换结果',
      matches: '匹配结果',
      hit: '命中 {n} 处',
      none: '无匹配',
      pos: '位置',
      text: '匹配内容',
      groups: '分组',
      preview: '替换预览',
      tokens: '常用元字符',
      escapeSel: '转义选中/剪贴板文本',
      needCopy: '请先复制要转义的文本',
      escaped: '已转义为字面量正则',
      needPattern: '请输入正则表达式',
      invalid: '正则无效',
      replaceFail: '替换失败',
      runFail: '执行失败',
      g: 'g 全局',
      gTip: '匹配全部，而非只找第一个',
      i: 'i 忽略大小写',
      iTip: 'A 与 a 同等匹配',
      m: 'm 多行',
      mTip: '^ $ 匹配每行首尾',
      s: 's 点号通配',
      sTip: '. 可匹配换行',
      u: 'u Unicode',
      uTip: '按 Unicode 码点处理',
      y: 'y 粘滞',
      yTip: '从 lastIndex 位置连续匹配',
      p: {
        email: { name: '邮箱', desc: '常见邮箱格式' },
        'mobile-cn': { name: '中国大陆手机号', desc: '11 位手机号' },
        url: { name: 'URL / 网址', desc: 'http/https 链接' },
        ipv4: { name: 'IPv4', desc: 'IPv4 地址' },
        'id-card': { name: '身份证号', desc: '18 位身份证（结构校验）' },
        'date-ymd': { name: '日期 YYYY-MM-DD', desc: '年月日' },
        'time-hms': { name: '时间 HH:mm:ss', desc: '24 小时制' },
        chinese: { name: '中文字符', desc: '连续汉字' },
        number: { name: '整数 / 小数', desc: '数字' },
        'hex-color': { name: '十六进制颜色', desc: 'CSS 颜色' },
        username: { name: '用户名', desc: '字母开头 4～16 位' },
        password: { name: '强密码', desc: '大小写+数字+特殊字符，≥8' },
        'html-tag': { name: 'HTML 标签', desc: '简易标签匹配' },
        'blank-line': { name: '空行', desc: '空行或仅空白' },
        'trim-spaces': { name: '首尾空白', desc: '行首行尾空格' }
      }
    },
    pixel: {
      tip: '按 DPI 在像素与厘米 / 英寸 / 毫米之间换算；也可上传图片读取像素尺寸与 EXIF DPI。单张图片不超过 50MB。',
      ph: '输入数值',
      custom: '自定义',
      unit: '单位',
      value: '数值',
      action: '操作',
      fromImage: '从图片读取',
      drop: '上传图片读取宽高 / EXIF DPI',
      apply: '填入宽度并换算',
      print: '打印尺寸（{dpi} DPI）',
      px: '像素 (px)',
      inch: '英寸 (in)',
      cm: '厘米 (cm)',
      mm: '毫米 (mm)',
      dpi72: '72（屏幕）',
      dpi96: '96（Windows）',
      dpi150: '150（草稿印刷）',
      dpi300: '300（印刷）',
      readFail: '读取失败',
      invalid: '请输入有效数值'
    },
    net: {
      ipTitle: 'IP 归属地查询',
      ipDesc: '查询 IP 国家 / 省份 / 城市 / 运营商',
      ipPh: '输入 IPv4 地址，如 8.8.8.8',
      quick: '快捷：',
      continent: '大洲',
      country: '国家/地区',
      province: '省份',
      city: '城市',
      isp: '运营商',
      countryCode: '国家代码',
      latlng: '经纬度',
      raw: '原始数据',
      ipEmpty: '未找到此 IP 的归属信息',
      needIp: '请输入 IP 地址',
      domainTitle: '域名 IP 查询',
      domainDesc: '解析域名 A/AAAA 记录，并自动查询每个 IPv4 的离线归属地',
      domainPh: '输入域名，如 github.com 或 https://example.com',
      domainPrepend: '域名',
      resolve: '解析',
      ipCount: '{n} 个 IP',
      engineOff: 'IP 归属地离线库未就绪，仅展示 DNS 解析结果',
      noGeo: '暂无归属地数据',
      dnsRaw: '查看原始 DNS 记录（{n} 条）',
      needDomain: '请输入域名',
      resolveFail: '解析失败',
      speedTitle: '宽带测速',
      speedDesc: '测浏览器到本站的延迟、下载与上传速度。结果受服务器带宽与路径影响，不等于运营商套餐峰值。',
      downSize: '下载包大小',
      upSize: '上传包大小',
      startSpeed: '开始测速',
      stop: '停止',
      speedResult: '测速结果',
      latency: '延迟 (RTT)',
      downSpeed: '下载速度',
      upSpeed: '上传速度',
      downTime: '下载耗时',
      upTime: '上传耗时',
      transfer: '传输量',
      hintStart: '点击开始后将依次测延迟 → 下载 → 上传。',
      hintRun: '正在测速，请勿关闭页面…',
      hintDone: '测速完成。数值为本站路径实测，仅供参考。',
      hintStop: '已停止测速。',
      phasePing: '测延迟中…',
      phaseDown: '下载测速中…',
      phaseUp: '上传测速中…',
      phaseRun: '测速中…',
      speedOk: '测速完成',
      speedFail: '测速失败',
      downFail: '下载测速失败',
      qAliDns: '阿里 DNS',
      qBaidu: '百度',
      qSite: '本站'
    },
    netops: {
      latencyTitle: '主机延迟测试',
      latencyDesc: '对公网域名/IP 做 TCP 建连测速（非 ICMP Ping）。探测由本站服务器发出，禁止内网/回环目标。',
      latencyPh: '例如 1.1.1.1 或 www.baidu.com',
      startTest: '开始测试',
      quick: '快捷',
      target: '目标',
      resolvedIp: '解析 IP',
      port: '端口',
      reachable: '连通',
      ok: '成功',
      fail: '失败',
      avg: '平均延迟',
      minMax: '最小 / 最大',
      okCount: '成功次数',
      noteTcp: 'TCP 建连耗时，非 ICMP Ping',
      needTarget: '请输入域名或 IP',
      probeFail: '探测失败',
      lanTitle: '内网 IP 检查',
      lanDesc: '通过 WebRTC 候选与本站出口对照，查看本机可能的局域网地址与公网 IP（浏览器能力因环境而异）。',
      refresh: '重新检测',
      localIp: '疑似内网 IP',
      publicIp: '公网出口 IP',
      publicLoc: '公网归属',
      status: '状态',
      lanNote: '部分浏览器/公司网络会隐藏 host 候选；完整内网扫描请用小程序「内网 IP / 监控检测」。',
      detected: '已检测',
      undetected: '未检测',
      lanEmpty: '未能读取到地址，可换浏览器或改用小程序',
      lanFail: '检测失败',
      camTitle: '监控摄像头检测',
      camDesc: '局域网端口扫描受浏览器同源策略限制。请使用微信小程序「网络运维 → 监控摄像头检测」，在同一 Wi‑Fi 下探测常见监控 Web 端口。',
      cam1: '小程序可在授权范围内请求局域网地址',
      cam2: '网站端仅作说明，避免无效的跨域探测',
      cam3: '也可配合「内网速率测试」检查两台设备互通',
      privA: 'A 类私网 (10.0.0.0/8)',
      privB: 'B 类私网 (172.16.0.0/12)',
      privC: 'C 类私网 (192.168.0.0/16)',
      loopback: '回环',
      other: '疑似公网或其它',
      qBaidu: '百度',
      qAliDns: '阿里 DNS',
      qSite: '本站'
    },
    beian: {
      eyebrow: '站长合规 · 需登录',
      title: '备案信息查询',
      desc: '登录后可查询网站 / APP / 小程序 / 快应用 ICP 备案；会员可创建开放 API，供脚本与系统对接。',
      tabQuery: '在线查询',
      tabApi: '开放 API',
      member: '会员',
      try: '试试：',
      openOfficial: '打开官方查询',
      officialTitle: '前往公安部官方平台查询网安备案',
      keyword: '关键词：',
      copyKw: '复制关键词',
      total: '共 {n} 条',
      officialLink: '官方复核',
      empty: '未查到备案信息',
      apiTitle: '开放 API 开发说明',
      apiDesc: '会员可创建个人令牌，通过 HTTP 调用备案查询接口，适合脚本、运维与内部系统集成。',
      memberOn: '会员已开通',
      needMember: '需会员',
      apiOnlyMember: '开放 API 仅会员可用',
      apiOnlyMemberDesc: '网页查询登录即可；创建/轮换 API 令牌需要会员身份。',
      goMember: '去开通会员',
      goMemberHint: '开通后即可在此生成令牌并查看完整调用文档',
      token: 'API 令牌',
      enabled: '已启用',
      notCreated: '未创建',
      tokenHintOn: '令牌已存在。完整明文仅在创建/轮换时展示一次，遗失请重新轮换。',
      tokenHintOff: '点击下方按钮创建令牌，即可开始调用。',
      rotate: '轮换令牌',
      create: '创建 API 令牌',
      closeApi: '关闭 API',
      authTitle: '1. 鉴权方式',
      authBody: '在请求头携带令牌（推荐）：',
      authCompat: '兼容：',
      queryApiTitle: '2. 查询接口',
      copyUrl: '复制 URL',
      param: '参数',
      explain: '说明',
      fieldsTitle: '3. 返回字段',
      field: '字段',
      curlTitle: '4. cURL 示例',
      jsTitle: '5. JavaScript 示例',
      notesTitle: '6. 注意事项',
      footerTitle: '说明',
      footer1: '网页查询需登录账号；开放 API 需会员令牌。',
      footer2: 'ICP 数据依赖服务器上游；网安默认引导官方查询。',
      footer3: '权威结果以工信部 / 公安部官方平台为准。',
      typeWeb: '网站备案',
      typeApp: 'APP 备案',
      typeMapp: '小程序备案',
      typeKapp: '快应用备案',
      typeWangan: '网安备案',
      phWeb: '输入域名 / 备案号 / 主办单位，如 baidu.com',
      phApp: '输入 APP 名称 / 主办单位 / 备案号',
      phMapp: '输入小程序名称 / 主办单位 / 备案号',
      phKapp: '输入快应用名称 / 主办单位 / 备案号',
      phWangan: '输入域名，将引导至公安官方查询',
      phDefault: '输入查询关键词',
      prependDomain: '域名',
      prependKw: '关键词',
      hintWangan: '网安备案默认打开公安官方查询页；已配置付费上游时将直接返回结果。',
      hintIcp: '支持域名、服务名称、主办单位名称或备案号查询。',
      statusChecking: '正在检测服务…',
      statusApiMember: '会员开放 API',
      statusApiNeed: '开放 API 需会员',
      statusReady: 'ICP 查询已就绪',
      statusNotReady: 'ICP 上游未就绪',
      statusWait: '请稍候',
      statusApiOk: '可创建令牌并调用接口',
      statusApiHint: '请先开通会员',
      statusFail: '无法获取服务状态',
      loadApiFail: '加载开放 API 失败',
      confirmRotate: '轮换后旧令牌立即失效，确认继续？',
      confirmCreate: '将创建备案查询开放 API 令牌，确认？',
      confirmTitle: '开放 API',
      confirmClose: '关闭后令牌立即失效，确认？',
      closeTitle: '关闭开放 API',
      closed: '已关闭',
      record: '备案记录',
      fDomain: '域名',
      fSiteName: '网站名称',
      fOwner: '开办者',
      fOwnerType: '主体类型',
      fBeianCode: '备案号',
      fPolice: '备案机关',
      fBeianDate: '备案时间',
      fSiteType: '网站类型',
      fUnit: '主办单位',
      fService: '服务名称',
      fMainLicence: '主体备案号',
      fServiceLicence: '服务备案号',
      fPassTime: '审核通过',
      fContentType: '前置审批',
      fAddress: '主体地址',
      nothingCopy: '没有可复制内容',
      needKw: '请输入查询关键词',
      wanganMsg: '网安备案暂无长期免费稳定开放接口。请前往公安部官方平台查询。',
      queryFail: '查询失败'
    },
    ico: {
      drop: '拖拽或点击上传图片，本地转码为 ICO',
      clear: '清除',
      unnamed: '未命名图片',
      quickTitle: '快捷方案',
      quickSub: '一键勾选常用组合',
      sizesTitle: '导出尺寸',
      selectAll: '全选',
      faviconOnly: '仅 Favicon',
      clearSel: '清空',
      custom: '自定义',
      addSize: '添加 {n}×{n}',
      extraAdded: '已添加自定义：',
      fitTitle: '适配方式',
      bgTitle: '背景',
      transparent: '透明',
      solid: '纯色',
      bgHint: '适合 PNG 透明图做 Favicon',
      genDownload: '生成并下载 ICO',
      packCount: '将打包 {n} 个尺寸',
      preview: '实时预览',
      tiers: '{n} 档',
      previewEmpty: '上传图片后，这里会按所选尺寸预览图标效果',
      needSize: '请至少选择一个导出尺寸',
      tips: '小提示',
      tip1: '建议使用正方形、透明底 PNG 作为源图',
      tip2: '网站 Favicon 常用 16 / 32 / 48',
      tip3: '文件在浏览器本地生成，不会上传服务器',
      tip4: '生成后可直接命名为 favicon.ico 放到网站根目录',
      customTip: '自定义尺寸',
      genOk: '已生成 {name}（{n} 个尺寸，约 {kb} KB）',
      convertFail: '转换失败',
      fitContain: '完整显示',
      fitContainHint: '等比缩放并居中，不足处留边（推荐）',
      fitCover: '裁切铺满',
      fitCoverHint: '等比放大铺满画布，多余部分居中裁切',
      fitStretch: '拉伸填满',
      fitStretchHint: '强制拉满正方形，可能变形',
      qFavicon: '网站 Favicon',
      qWindows: 'Windows 图标',
      qApp: '应用图标',
      qAll: '全部尺寸',
      tip16: '浏览器标签 / 经典 Favicon',
      tip24: '部分工具栏图标',
      tip32: '高清 Favicon / 任务栏',
      tip48: 'Windows 资源管理器',
      tip64: '桌面快捷方式',
      tip128: '高分屏图标',
      tip256: 'Vista+ 大图标'
    },
    exif: {
      lead: '上传照片读取并编辑完整 EXIF：设备序列号、镜头 / 闪光灯、对比度 / 饱和度 / 清晰度、光源、白平衡、EXIF 版本、详细 GPS 等均可设置。支持设备 / 画质 / 光源 / 闪光灯 / 镜头预设，也可保存自定义预设。导出 JPEG（本地处理）。',
      drop: '选择或拖入照片（JPEG / PNG / WebP，≤50MB）',
      hasExif: '已读到原有 EXIF',
      noExif: '无 EXIF / 非 JPEG，可手动添加',
      stampNow: '时间设为现在',
      justShot: '一键「刚拍」',
      saveCustom: '存为自定义',
      clearFields: '清空字段',
      export: '导出',
      exportHint: '将当前全部字段写入 JPEG EXIF 并下载。原 JPEG 不重编码保真；非 JPEG 会先转 JPEG。',
      jpegQuality: 'JPEG 质量',
      fileName: '文件名',
      exportBtn: '导出带 EXIF 的 JPEG',
      devicePresets: '设备一键预设',
      styleBlock: '画质 · 光源 · 闪光灯 · 镜头',
      style: '画质风格',
      light: '光源',
      flash: '闪光灯',
      lens: '镜头',
      myPresets: '我的自定义预设',
      delete: '删除',
      gpsBlock: 'GPS 城市快捷（含精度 / 状态 / 区域）',
      clearGps: '清除 GPS',
      searchPh: '搜索字段（如 序列号、对比度、GPS）',
      onlyFilled: '仅看已填写',
      select: '选择',
      readFail: '读取失败',
      sizeFail: '无法读取图片尺寸',
      applied: '已套用：{label}',
      appliedDevice: '已套用 {brand} {name}',
      gpsFilled: '已填入 {name} GPS 详情',
      timeSet: '拍摄时间已设为当前',
      justShotOk: '已补全为「刚拍摄」参数',
      saveTitle: '保存自定义预设',
      savePrompt: '为当前字段组合起个名字',
      savePh: '如：街头夜景 / 人像棚拍',
      save: '保存',
      cancel: '取消',
      saved: '已保存自定义预设',
      exported: '已导出',
      exportFail: '导出失败'
    },
    ocr: {
      eyebrow: '阿里云读光 · 文件 OCR',
      title: '图片与文件智能识别',
      desc: '通用文字、卡证、票证发票、车辆物流与试卷识别。支持图片与 PDF；获管理员授权后可使用开放 API 对接业务系统。',
      available: '可用',
      pickScene: '选择场景',
      quota: '额度 {n}/月',
      notReadyEm: '服务未就绪，请联系管理员',
      pausedEm: '当前暂不可用',
      notReady: '服务未就绪',
      notReadyBody: '请管理员在后台「阿里云 OCR」配置 AccessKey 后使用。',
      tabRec: '在线识别',
      tabApi: '开放 API',
      authorized: '已授权',
      replace: '点击或拖拽替换',
      replaceClick: '点击替换',
      dropTitle: '拖拽图片或 PDF 到此处',
      dropHint: 'JPG / PNG / BMP / WebP / GIF / TIFF / PDF / OFD · 约 10MB 内',
      clear: '清除',
      typeLabel: '识别类型',
      typePh: '选择 Type',
      pageLabel: 'PDF / OFD 页码（可选）',
      pageTip: '多页文件可指定页码；不填则识别第一页。',
      keysLabel: '抽取字段（可选，逗号分隔）',
      keysPh: '如：姓名,地址,开票日期；留空由模型自动判断',
      outputTable: '输出表格结构',
      result: '识别结果',
      text: '文本',
      emptyText: '（无纯文本，可切换 JSON 查看）',
      resultEmpty: '选择场景并上传文件后开始识别',
      apiTitle: '开放 API 开发说明',
      apiDesc: '管理员授权后可创建个人令牌，通过 HTTP 调用 OCR 识别接口，适合业务系统与脚本对接。',
      apiOk: '已获授权',
      needAdmin: '需管理员开通',
      apiNeedTitle: '开放 API 需管理员授权',
      apiNeedDesc: '请联系管理员在后台「用户 → 工具配置」开通 OCR API 并设置每月次数。用户不可自行开通。',
      notOpened: '暂未开通',
      notOpenedHint: '网页识别可正常使用；开放接口需单独授权。',
      token: 'API 令牌',
      enabled: '已启用',
      notCreated: '未创建',
      used: '已用 {used} / {limit}',
      remaining: '剩余 {n}',
      tokenHintOn: '令牌已存在。完整明文仅在创建/轮换时展示一次，遗失请重新轮换。',
      tokenHintOff: '点击下方按钮创建令牌，即可开始调用。',
      rotate: '轮换令牌',
      create: '创建 API 令牌',
      closeToken: '关闭令牌',
      authTitle: '1. 鉴权方式',
      authBody: '在请求头携带令牌（推荐）：',
      authCompat: '兼容：',
      queryTitle: '2. 识别接口',
      copyUrl: '复制 URL',
      param: '参数',
      explain: '说明',
      fieldsTitle: '3. 返回字段',
      field: '字段',
      scenesTitle: '4. 场景 ID（sceneId）',
      curlTitle: '5. cURL 示例',
      jsTitle: '6. JavaScript 示例',
      notesTitle: '7. 注意事项',
      btnNotReady: '服务未就绪',
      btnPaused: '暂不可用',
      btnNeedFile: '请先上传文件',
      btnRun: '开始识别',
      loadFail: '加载 OCR 状态失败',
      tooLarge: '文件过大，请控制在约 10MB 内',
      recOk: '识别成功',
      unavailable: '暂不可用',
      recFail: '识别失败',
      loadApiFail: '加载开放 API 失败',
      confirmRotate: '轮换后旧令牌立即失效，确认继续？',
      confirmCreate: '将创建 OCR 开放 API 令牌，确认？',
      confirmTitle: '开放 API',
      tokenCreated: '令牌已生成，请立即复制保存',
      confirmClose: '关闭后令牌立即失效，确认？',
      closeTitle: '关闭开放 API',
      closed: '已关闭令牌'
    },
    battery: {
      tip: '电池容量、串并联、续航与 C 倍率换算，适合储能与数码电池估算。',
      tabCap: '容量换算',
      tabPack: '串并联',
      tabRuntime: '续航估算',
      tabCrate: 'C 倍率',
      presets: '常用电芯：',
      voltage: '电压 V',
      mah: '容量 mAh',
      orWh: '或能量 Wh',
      cellV: '单节电压 V',
      cellMah: '单节容量 mAh',
      series: '串联 S',
      parallel: '并联 P',
      loadMa: '负载电流 mA',
      efficiency: '效率 %',
      cRate: 'C 倍率',
      orCurrentA: '或电流 A',
      calc: '计算',
      fail: '计算失败',
      errVoltage: '请输入有效标称电压 (V)',
      errMahOrWh: '请填写 mAh 或 Wh 其中一项',
      errCell: '请填写有效的单节电压与容量',
      errRuntime: '请填写容量与负载电流',
      errMah: '请填写电池容量 (mAh)',
      errCrate: '请填写 C 倍率或放电电流',
      r: {
        voltage: '电压 V',
        mAh: '容量 mAh',
        Ah: '容量 Ah',
        Wh: '能量 Wh',
        combo: '组合',
        cells: '节数',
        packV: '总电压 V',
        packMah: '总容量 mAh',
        packAh: '总容量 Ah',
        packWh: '总能量 Wh',
        hours: '续航小时',
        minutes: '续航分钟',
        days: '约合天',
        efficiency: '效率 %',
        cRate: 'C 倍率',
        currentA: '电流 A',
        currentMa: '电流 mA',
        ah: '容量 Ah'
      }
    },
    recording: {
      tabSize: '计算录像大小',
      tabTime: '计算录像时间',
      tabBw: '带宽计算',
      tipSize: '按编码、分辨率（或自定义码率）、路数与存储天数估算连续录像所需硬盘容量。码率为行业常用参考值，实际因场景复杂度而异。',
      tipTime: '已知硬盘总容量时，估算在当前画质与路数下大约可连续存储多久。',
      tipBw: '按摄像机数量与单路码率估算录像/预览所需网络带宽，并给出约 20% 预留建议。',
      conditions: '计算条件',
      byResolution: '分辨率',
      byBitrate: '码率',
      codec: '编码格式',
      resolution: '分辨率',
      fps: '帧率',
      bitrate: '码率',
      recBitrate: '推荐码率',
      cameras: '摄像头数量',
      camerasPh: '例如 16',
      duration: '存储时间',
      durationPh: '例如 30',
      capacity: '硬盘总容量',
      capacityPh: '例如 8',
      reset: '重置',
      calc: '计算',
      result: '计算结果',
      sizeSub: '连续录像约需容量（{cameras} 路 × {bitrate} Kbps × {days} 天）',
      exact: '精确值',
      suggestDisk: '建议硬盘',
      sizeNote: '建议预留约 15% 冗余（格式化损耗、索引与突发码率）。',
      timeSub: '在 {cap} 容量下约可连续存储',
      days: '天数',
      hours: '小时',
      months: '约合月数',
      dayUnit: '天',
      hourUnit: '小时',
      monthUnit: '个月',
      bwSub: '{cameras} 路合计码流（单路 {bitrate} Kbps）',
      totalBw: '总带宽',
      suggestBw: '建议预留',
      bwNote: '建议链路带宽预留约 20%，并考虑交换机背板与录像机接入能力。',
      needBitrate: '请填写有效码率',
      fail: '计算失败',
      errBw: '请填写有效的摄像头数量与码率',
      errSize: '请填写有效的摄像头数量、码率与存储时间',
      errTime: '请填写有效的摄像头数量、码率与硬盘容量',
      uDay: '天',
      uHour: '小时',
      uMonth: '月(30天)',
      aboutDays: '约 {n} GB',
      aboutTb: '约 {n} TB'
    },
    eng: {
      disclaimer: '结果供参考，重要工程请按规范复核。',
      calc: '计算',
      calcSize: '计算线径',
      fail: '计算失败',
      result: '计算结果',
      byCurrent: '按电流',
      byPower: '按功率',
      singlePhase: '单相',
      threePhase: '三相',
      extraTag: '超大估算',
      dia: '约直径 φ{n} mm',
      ampacity: '载流量约 {n} A',
      drop: '压降约 {n} V（{p}%）',
      limitedBy: '由{what}决定',
      byDrop: '压降',
      byAmpacity: '载流量',
      cableTitle: '线缆选型计算（铜 / 铝 / 金 / 铜包铝）',
      cableTipPower: '输入负载功率与线路长度，自动按载流量与压降推荐截面积。',
      cableTipCurrent: '输入负载电流与线路长度，自动按载流量与压降推荐截面积。',
      mat: { cu: '铜线', al: '铝线', au: '金线', cca: '铜包铝' },
      tip: {
        'cable-size': '按电流或功率与长度推荐铜线、铝线、金线、铜包铝截面积。',
        'electrician-calc': '电工常用计算：电流电压功率、电缆压降、电机、三相、电阻电感等。',
        'room-calc': '房间面积、图形面积、空调选型与涂料地板用量估算。',
        'unit-calc': '长度、面积、温度与百分比折扣换算。',
        'science-calc': '圆柱体、三角形、四边形、圆与球体等数学公式计算。',
        'other-tools': '电工、线缆、房间面积等计算器合集，可从左侧切换。'
      },
      m: {
        'cable-size': { title: '线缆选型', desc: '电流或功率→铜/铝/金/铜包铝线径' },
        electric: { title: '电流电压功率', desc: '电工基础互算' },
        bill: { title: '电费估算', desc: '功率×时间算电量电费' },
        cable: { title: '电缆压降', desc: '已知线径算压降' },
        motor: { title: '电机电流/功率', desc: '电机电流与功率互算' },
        'delta-wye': { title: '三角/星形功率', desc: '三相接法与功率换算' },
        resistance: { title: '电阻计算', desc: '欧姆定律 / LED 限流' },
        inductance: { title: '电感计算', desc: '感抗与串并联' },
        circuit: { title: '经典电路', desc: '功率、RC、容抗' },
        component: { title: '元器件计算', desc: '截止频率 / 谐振 / 分压' },
        cylinder: { title: '气缸压力', desc: '气缸推力与压力计算' },
        room: { title: '房间面积', desc: '长宽面积、体积、多房间' },
        shape: { title: '图形面积', desc: '矩形/三角/圆/梯形' },
        'area-unit': { title: '面积单位', desc: '㎡/亩/公顷/坪互转' },
        ac: { title: '空调选型', desc: '房间面积适配空调匹数' },
        material: { title: '涂料地板', desc: '按面积估算材料用量' },
        length: { title: '长度换算', desc: '毫米/米/英尺等互转' },
        temp: { title: '温度换算', desc: '摄氏/华氏/开尔文' },
        percent: { title: '百分比折扣', desc: '占比、折扣与优惠' },
        'math-rect': { title: '长方形/正方形', desc: '周长、面积、对角线' },
        'math-isosceles': { title: '等腰三角形', desc: '腰底高、面积、角度' },
        'math-triangle': { title: '三角形', desc: '三边/两边夹角/底高' },
        'math-quad': { title: '四边形', desc: '平行四边形/梯形/一般四边形' },
        'math-cylinder': { title: '圆柱体', desc: '底面积、侧面积、体积' },
        'math-circle': { title: '圆', desc: '周长与面积' },
        'math-sphere': { title: '球体', desc: '表面积与体积' },
        'math-cube': { title: '正方体', desc: '表面积、体积、体对角线' },
        'math-pythagoras': { title: '勾股定理', desc: '直角三角形边长' }
      },
      r: {
        drop: '压降 (V)',
        percent: '压降百分比 (%)',
        endVoltage: '末端电压 (V)',
        resistanceOne: '单线电阻 (Ω)',
        tip: '提示',
        current: '电流 (A)',
        inputPowerKw: '输入功率 (kW)',
        apparentKva: '视在功率 (kVA)',
        formula: '公式',
        powerKw: '输出功率 (kW)',
        horsepower: '约合马力 (HP)',
        connection: '接法',
        lineVoltage: '线电压 UL (V)',
        phaseVoltage: '相电压 UP (V)',
        lineCurrent: '线电流 IL (A)',
        phaseCurrent: '相电流 IP (A)',
        activeKw: '有功功率 (kW)',
        reactiveKvar: '无功功率 (kvar)',
        areaMm2: '活塞面积 (mm²)',
        pushForceN: '伸出推力 (N)',
        pushForceKg: '伸出推力 (kgf)',
        pullForceN: '收回拉力 (N)',
        pullForceKg: '收回拉力 (kgf)',
        pressureBar: '压力 (bar)',
        pressureMpa: '压力 (MPa)',
        xl: '感抗 XL (Ω)',
        inductanceMh: '电感 L (mH)',
        totalMh: '等效电感 (mH)',
        resistance: '电阻 (Ω)',
        voltage: '电压 (V)',
        total: '等效电阻 (Ω)',
        powerW: '功率 (W)',
        tauSec: '时间常数 τ (s)',
        tauMs: '时间常数 τ (ms)',
        settle5Tau: '约 5τ (s)',
        xc: '容抗 Xc (Ω)',
        cutoffHz: '截止频率 (Hz)',
        resonateHz: '谐振频率 (Hz)',
        vout: '输出电压 (V)',
        ratio: '分压比',
        coolingW: '制冷量 (W)',
        coolingKw: '制冷量 (kW)',
        coolingBtu: '制冷量 (BTU/h)',
        suggestHp: '建议匹数',
        areaM2: '面积 (m²)',
        m2: '平方米 m²',
        mu: '亩',
        hectare: '公顷',
        ping: '坪',
        sqft: '平方英尺',
        cm2: '平方厘米',
        areaPing: '约合坪',
        areaSqft: '约合平方英尺',
        perimeterM: '周长 (m)',
        volumeM3: '体积 (m³)',
        wallAreaM2: '四面墙面积 (m²)',
        heightM: '层高 (m)',
        roomsDetail: '分项',
        area: '面积',
        circumference: '周长',
        mm: '毫米 mm',
        cm: '厘米 cm',
        m: '米 m',
        km: '千米 km',
        inch: '英寸 inch',
        ft: '英尺 ft',
        celsius: '摄氏 °C',
        fahrenheit: '华氏 °F',
        kelvin: '开尔文 K',
        result: '结果',
        finalPrice: '折后价',
        saved: '立减',
        offPercent: '优惠幅度 (%)',
        netAreaM2: '净面积 (m²)',
        withWasteM2: '含损耗面积 (m²)',
        paintLiters: '涂料约需 (L)',
        pieces: '地板约需 (片)',
        pieceAreaM2: '单片面积 (m²)',
        loadCurrentA: '负载电流 (A)',
        designCurrentA: '设计电流 (A)',
        lengthM: '线路长度 (m)',
        voltageV: '电压 (V)',
        phases: '相数',
        safetyFactor: '安全系数',
        recommendCu: '铜线建议',
        recommendAl: '铝线建议',
        recommendAu: '金线建议',
        recommendCca: '铜包铝建议',
        detailCu: '铜线说明',
        detailAl: '铝线说明',
        detailAu: '金线说明',
        detailCca: '铜包铝说明',
        kwh: '电量 (kWh)',
        cost: '预估电费 (元)',
        dailyKwh: '日用电量 (kWh)',
        inputMode: '输入方式',
        loadPowerW: '负载功率 (W)',
        loadPowerKw: '负载功率 (kW)',
        powerUnit: '功率单位',
        side: '边长 / 棱长',
        length: '长度',
        width: '宽度',
        perimeter: '周长',
        diagonal: '对角线',
        equalSide: '腰长',
        base: '底边',
        height: '高',
        apexAngleDeg: '顶角 (°)',
        baseAngleDeg: '底角 (°)',
        sideC: '第三边 c',
        semiPerimeter: '半周长',
        baseArea: '底面积',
        lateralArea: '侧面积',
        surfaceArea: '表面积',
        volume: '体积',
        radius: '半径',
        diameter: '直径',
        faceArea: '单面面积',
        spaceDiagonal: '体对角线',
        hypotenuse: '斜边',
        otherLeg: '另一直角边'
      }
    }
  },
  about: {
    browseArticles: '浏览文章',
    contactMe: '联系我',
    role: '前端开发者 · 技术写作者',
    bio1: '一名热爱技术的前端开发者，专注于 Web 前端工程化与用户体验设计。这个博客是我记录学习笔记、技术思考、软件推荐与项目经验的地方。',
    bio2: '希望把复杂的技术问题讲清楚，把好用的工具分享给大家，让每一次阅读都有所收获。',
    online: '在线创作中',
    focusEyebrow: 'FOCUS',
    focusTitle: '我在做什么',
    focusSub: '用写作沉淀经验，用分享连接更多开发者',
    focusWrite: '技术写作',
    focusWriteDesc: '分享前端开发经验、工程化实践与性能优化思路，把复杂问题讲清楚。',
    focusTools: '工具推荐',
    focusToolsDesc: '精选实用软件与小工具，提升日常开发与学习效率。',
    focusTutorial: '教程实战',
    focusTutorialDesc: '从入门到进阶的项目教程，帮助读者建立完整的知识体系。',
    contentEyebrow: 'CONTENT',
    contentTitle: '博客内容方向',
    contentSub: '四大栏目，覆盖从入门到进阶的学习路径',
    techDesc: '前端开发、性能优化、工程实践',
    softwareDesc: '小工具、办公与开发效率软件',
    tutorialDesc: '入门到进阶的系统化学习',
    resourceDesc: '学习资料、开源项目与书籍',
    statArticles: '文章总数',
    statTech: '技术文章',
    statSoftware: '软件推荐',
    statTutorialResource: '教程 & 资源',
    techGroupFront: '前端框架',
    techGroupLang: '语言与样式',
    techGroupEng: '工程化',
    techGroupOther: '其他',
    tagEng: '工程化',
    tagUx: '用户体验',
    articleCount: '{n} 篇文章',
    stackTitle: '技术栈',
    stackSub: '日常开发与技术写作中频繁使用的工具与框架',
    ctaTitle: '一起交流，共同进步',
    ctaDesc: '欢迎通过邮件交流技术问题、合作事宜或内容建议。也欢迎关注与支持本站持续创作。',
    sponsorSupport: '赞助支持'
  },
  sponsor: {
    badge: '赞助会员',
    title: '支持{name}，解锁更多优质内容',
    desc: '您的赞助将帮助站点持续更新教程、软件推荐与技术文章。选择合适方式开通或续费会员。',
    memberUntil: '当前赞助有效期至',
    renewNote: '续费将在到期日基础上延长',
    plansRenew: '续费套餐',
    plansBuy: '会员套餐',
    plansDirectTip: '选择套餐完成赞助，支付成功后自动开通会员',
    plansExternalTip: '选择合适套餐前往发卡平台购买，购买后返回本站兑换 CDK 激活',
    plansIntroTip: '以下为会员套餐介绍，购买后请使用兑换码激活',
    originalPrice: '原价 ¥{price}',
    unitPrice: '折合 {unit}',
    renew: '续费',
    sponsorNow: '立即赞助',
    goBuy: '前往购买',
    onlineBuy: '在线购买会员',
    empty: '会员购买功能暂未开放，请联系管理员',
    faqTitle: '常见问题',
    faq1q: '赞助后可以使用哪些权益？',
    faq1a: '可阅读全站标注为「会员专享」的文章与章节，并在个人中心查看赞助订单记录。',
    faq2q: '续费如何计算有效期？',
    faq2a: '若当前赞助未过期，新套餐时长将在原到期日基础上叠加；若已过期，则从激活日起算。',
    faq3q: 'CDK 兑换码如何使用？',
    faq3a: '在发卡平台购买会员后获得兑换码，登录本站后在上方输入框填写并点击「立即兑换」即可激活对应套餐时长。',
    faq4q: '购买后如何激活？',
    faq4a: '在发卡平台完成购买后，返回本页输入收到的 CDK 兑换码即可自动激活会员。',
    cdkReturnHint: '购买后请返回此页输入兑换码完成激活',
    confirmRenew: '续费',
    confirmSponsor: '赞助',
    confirmTitle: '{action}赞助会员',
    confirmMsg: '确认{action}「{name}」？（¥{price}，{duration}）',
    confirmOk: '确认{action}',
    cancel: '取消'
  },
  profile: {
    member: '赞助会员',
    normalUser: '普通用户',
    joinedAt: '加入于 {date}',
    memberUntil: '赞助至 {date}',
    changeAvatar: '更换头像',
    admin: '系统后台',
    renew: '续费赞助',
    openSponsor: '开通赞助',
    history: '浏览记录',
    orders: '订单',
    unlocked: '已解锁',
    sideLabel: '账户中心',
    navAria: '个人中心导航',
    tabInfo: '个人信息',
    tabInfoShort: '资料',
    tabSecurity: '账号安全',
    tabSecurityShort: '安全',
    tabHistory: '浏览历史',
    tabHistoryShort: '历史',
    tabPoints: '我的积分',
    tabPointsShort: '积分',
    tabMember: '赞助会员',
    tabMemberShort: '会员',
    tabOrders: '赞助订单',
    tabOrdersShort: '订单',
    guestTitle: '登录后管理个人中心',
    guestDesc: '同步浏览历史、积分签到、赞助会员与订单记录',
    loginNow: '立即登录'
  },
  copyright: {
    backHome: '返回首页',
    title: '版权声明',
    desc: '欢迎访问「{name}」网站。请仔细阅读以下条款，使用本站即表示您已阅读并同意本声明的全部内容。',
    updated: '最后更新：2026 年 3 月 10 日',
    effective: '生效日期：2026 年 1 月 1 日',
    toc: '目录',
    contactPrefix: '如您对本声明有任何疑问，请通过邮箱',
    contactSuffix: '与我们联系。我们将在合理期限内予以回复。',
    enNotice: '英文版本仅供参考；如与中文内容不一致，以中文为准。'
  },
  redirect: {
    back: '返回上一页',
    leaving: '即将离开本站',
    invalid: '链接无效',
    leavingDesc: '您即将访问第三方网站，请确认目标地址后再继续。',
    invalidDesc: '无法识别或解析该链接，请检查地址是否正确。',
    targetSite: '目标网站',
    copy: '复制',
    copied: '已复制',
    linkName: '链接名称',
    fromArticle: '来源文章',
    safety: '安全提示',
    tip1: '第三方网站的内容、隐私政策与安全措施由该网站自行负责。',
    tip2: '请勿在未知页面输入账号、密码或支付信息。',
    tip3: '如遇可疑页面，请立即关闭并返回本站。',
    cancel: '取消返回',
    confirm: '确认前往',
    countdown: '点击确认后将在新标签页打开目标链接，本站页面保持不变',
    invalidReason: '可能原因：链接格式错误、协议不受支持，或缺少跳转参数。',
    backHome: '返回首页',
    footerTip: '{name} 对外链访问进行安全提示，保护您的浏览体验'
  },
  common: {
    langSwitched: '已切换语言',
    tip: '提示',
    backTop: '回到顶部',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    reply: '回复'
  },
  comments: {
    title: '评论',
    approvalTip: '评论需审核后公开显示，您自己的待审评论会标注「审核中」',
    placeholder: '写下你的想法，支持插入图片与链接…',
    submit: '发表评论',
    loading: '加载评论中…',
    empty: '还没有评论，来抢沙发吧',
    pending: '审核中',
    hidden: '已隐藏',
    replyTo: '回复',
    editPh: '编辑评论…',
    replyPh: '回复 @{name}…',
    submitReply: '发表回复',
    loadFailed: '加载评论失败',
    pickImage: '请选择图片文件',
    imageInserted: '图片已插入',
    uploadFailed: '图片上传失败',
    needContent: '请输入评论内容',
    needReply: '请输入回复内容',
    posted: '发表成功',
    postFailed: '发表失败',
    replied: '回复成功',
    replyFailed: '回复失败',
    emptyContent: '评论内容不能为空',
    updated: '评论已更新',
    updateFailed: '更新失败',
    deleteConfirm: '确定删除这条评论吗？',
    deleted: '评论已删除',
    deleteFailed: '删除失败'
  },
  auth: {
    login: '登录',
    logout: '退出登录',
    loggedOut: '已退出登录',
    register: '注册',
    createAccount: '创建账号',
    welcomeBack: '欢迎回来',
    joinUs: '加入我们',
    forgotTitle: '找回密码',
    welcomeDesc: '登录账号，继续你的阅读之旅',
    registerDesc: '创建账号，探索更多优质内容',
    qrDesc: '微信扫码，安全快捷登录网站',
    forgotDesc1: '通过注册邮箱验证身份，安全重置您的密码',
    forgotDesc2: '设置新密码后即可重新登录账号',
    featCollect: '收藏喜欢的文章',
    featHistory: '同步浏览历史记录',
    featPersonal: '个性化阅读体验',
    featEmail: '邮箱验证保障账号安全',
    featCode: '验证码 10 分钟内有效',
    featReset: '重置后可立即登录',
    passwordLogin: '账号登录',
    qrLogin: '小程序扫码',
    account: '账号',
    accountPh: '用户名或邮箱',
    password: '密码',
    passwordPh: '请输入密码',
    forgot: '忘记密码？',
    noAccount: '还没有账号？',
    registerNow: '立即注册',
    hasAccount: '已有账号？',
    loginNow: '立即登录',
    backLogin: '返回登录',
    username: '用户名',
    usernamePh: '须大于 5 位',
    email: '邮箱',
    emailCode: '邮箱验证码',
    codePh: '6 位验证码',
    getCode: '获取验证码',
    resendIn: '{n}s 后重发',
    resend: '重新发送',
    passwordRule: '须大于 8 位',
    confirmPassword: '确认密码',
    confirmPh: '再次输入密码',
    forgotHint1: '输入注册邮箱，获取验证码',
    forgotHint2: '设置您的新密码',
    registeredEmail: '注册邮箱',
    registeredEmailPh: '请输入注册时使用的邮箱',
    sendCode: '发送验证码',
    code: '验证码',
    newPassword: '新密码',
    newPasswordPh: '至少 6 位',
    qrAlt: '扫码登录',
    qrLoading: '二维码加载中…',
    qrExpired: '已过期，点击刷新',
    qrRefresh: '刷新二维码',
    qrPending: '请使用微信扫一扫打开小程序并确认登录',
    qrExpiredHint: '二维码已过期，请刷新',
    qrCancelled: '已取消，可刷新后重试',
    qrError: '二维码加载失败',
    rememberPassword: '想起密码了？',
    resetPassword: '重置密码',
    confirmNewPassword: '确认新密码',
    confirmNewPh: '再次输入新密码'
  },
  user: {
    menu: '用户菜单',
    member: '赞助会员',
    normal: '普通用户',
    expireUntil: '有效期至 {date}',
    openHint: '开通赞助解锁更多内容',
    checkin: '签到',
    checkinDaily: '每日签到',
    checkedIn: '已签到',
    checkedInToday: '今日已签到',
    checkinReward: '签到可得 +{n} {name}',
    profile: '个人中心',
    myPoints: '我的积分',
    history: '浏览历史',
    recent: '最近浏览',
    viewAll: '查看全部',
    noHistory: '还没有浏览记录',
    justNow: '刚刚',
    minutesAgo: '{n} 分钟前',
    hoursAgo: '{n} 小时前',
    streak: '已连续 {n} 天'
  }
}
